@if (files.length > 0) {
  <div class="ignored-files-notice">
    <button type="button" class="ignored-files-notice__toggle" (click)="expanded = !expanded">
      <i
        class="ph ph-caret-right ignored-files-notice__caret"
        [class.ignored-files-notice__caret--expanded]="expanded"
        aria-hidden="true"
      ></i>
      @if (files.length === 1) {
        {{ 'tenders.responses.documents.ignored-files-one' | translate }}
      } @else {
        {{ 'tenders.responses.documents.ignored-files-many' | translate: { count: files.length } }}
      }
    </button>
    @if (expanded) {
      <div class="ignored-files-notice__list">
        @for (entry of files; track entry.name) {
          <div class="ignored-files-notice__entry">
            <span class="ignored-files-notice__name">{{ entry.name }}</span>
            <span class="ignored-files-notice__reason">— {{ entry.reason | translate }}</span>
          </div>
        }
      </div>
    }
  </div>
}
